export enum BuySellEventName {
  OrderModalHide = '@buy-sell/order-modal/hide',
  OrderModalClose = '@buy-sell/order-modal/close',
}

export interface BuySellHideDetail {
  isHidden: boolean;
}
